export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    disabledClass() {
      return { ["is-disabled"]: this.disabled };
    },
  },
};
